import { mctRequest } from '@/api/axios'

export const mctUserInfoApi = <T = any>(userCEC: string): Promise<T> => {
  const config = {
    url: `/admin/member-info/${userCEC}`
  }
  return mctRequest.request<T>(config)
}

export const saveMctUserPreferencesApi = <T = any>(
  userId: number,
  data: {}
): Promise<T> => {
  const config = {
    url: `/admin/preference/memberId/${userId}`,
    method: 'post',
    data
  }
  return mctRequest.request<T>(config)
}
